<div class="blog-page-container">
  <!-- Blog Header Symbol (audience-based: BFW for highschool, Macmillan for highered) -->
  <app-blog-symbol-section 
    [apiKey]="apiKey" 
    [entryName]="headerSymbolName"
    position="header">
  </app-blog-symbol-section>

  <!-- Article Not Found State -->
  <div *ngIf="!article" class="error-container">
    <div class="error-icon">⚠️</div>
    <h2 class="error-title">Article Not Found</h2>
    <p class="error-message">The blog article you're looking for doesn't exist or has been removed.</p>
    <a href="/content-hub" class="back-link">← Back to Home</a>
  </div>

  <div *ngIf="article" class="blog-content-wrapper">
    <app-blog-article
      [title]="title"
      [excerpt]="excerpt"
      [publishedDate]="publishedDate"
      [author]="author"
      [bodyHtml]="contentHtml"
      [discipline]="discipline"
      [subject]="subject"
      [topics]="topics"
      [themes]="themes"
      [product]="product"
      [contentSeries]="contentSeries">
    </app-blog-article>

    <div class="builder-content-container">
      <builder-content
        [model]="model"
        [content]="article"
        [apiKey]="apiKey">
      </builder-content>
    </div>

    <app-blog-promo-section [apiKey]="apiKey"></app-blog-promo-section>
  </div>

  <!-- Blog Footer Symbol (audience-based: BFW for highschool, Macmillan for highered) -->
  <app-blog-symbol-section 
    [apiKey]="apiKey" 
    [entryName]="footerSymbolName"
    position="footer">
  </app-blog-symbol-section>
</div>

